<template>
  <ax-panel title="差补明细">
    <div :class="{'top-item':key!==0}" v-for="(item, key) in tripItineraryLines" :key="key" :title="item.name">
        <div class="exp_itinerary_cont_flex">
            <van-cell class="right-cell">
                <template slot="title">
                    <span class="custom-title">{{ item.travelDate | formatTime }}</span>
                    <span class="data">{{ item.businessDayFlag ? "工作日" : "周末节假日"}}</span>
                </template>
            </van-cell>
            <van-cell class="right-cell" title="差补金额：" :value="'￥'+item.amount" />
        </div>
        <div class="exp_itinerary_cont_flex">
            <van-cell class="right-cell">
                <template slot="title">
                    <span class="custom-title">出差地点：</span>
                    <span>{{ item.endPlace}}</span>
                    <img v-show="item.defaultMarkRemark" class="img_questions" src="@/assets/img/icon/questions.png" width="18" alt="index" @click="businessTrips(item.defaultMarkRemark)"/>
                </template>
            </van-cell>
            <van-cell class="right-cell" title="领取差补：" :value="item.travelMark ? '是' :'否'" :class="item.travelMark ? 'color_blue' :''"/>
        </div>
    </div>
  </ax-panel>
</template>

<script>
export default {
  props:{
    tripItineraryLines: Array
  },
  data() {
    return {};
  },
  methods:{
    businessTrips(data){
      let msg = JSON.parse(data).defaultEndPlaceMobile;
      this.$dialog.alert({
        message: msg,
      }).then(() => {})  
    }
  }
}
</script>
  
<style lang="scss" scoped>
@import '../../assets/css/exp.scss';
</style>
